<template>
  <label
    class="ms-radio"
    :class="{ 'rd-disabled': disabled }"
    @keypress="keyDownActive"
    @focus="onFocus"
    @blur="onBlur"
  >
    <div class="flex-row">
      <input
        type="radio"
        :name="name"
        :value="keyValue"
        :checked="modelValue === keyValue"
        @input="$emit('update:modelValue', keyValue)"
        @change="$emit('msChange', $event)"
        :disabled="disabled"
        :tabindex="0"
      />
      <span class="checkmark" v-tooltip="'Chọn'"></span>

      <div class="ms-rd-text flex">
        <div v-if="label" class="ms-radio--text">{{ label }}</div>
        <div v-if="title" class="ms-radio--tooltip">{{ title }}</div>
      </div>
    </div>
  </label>
</template>
<script>
export default {
  name: 'msRadio',
  props: {
    modelValue: {},
    label: {
      default: null,
      type: String,
    },
    title: {
      default: null,
      type: String,
    },
    keyValue: {
      default: null,
    },
    name: {
      default: null,
      type: String,
    },
    type: {
      default: 'radio',
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      focused: false,
    };
  },
  methods: {
    keyDownActive(e) {
      e.preventDefault();
      switch (e.which) {
        case 32:
        case 13:
          this.$emit('update:modelValue', this.keyValue);
          this.$el.querySelector('input[type="radio"]').focus();
          break;
      }
    },
    onFocus(e) {
      const me = this;
      me.focused = true;
    },
    onBlur(e) {
      const me = this;
      me.focused = false;
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
      };
    },
    checkHasEvent() {
      let me = this;
      if (me.checked) {
        return true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/components/MsRadio.scss';
</style>
